export default __webpack_public_path__ + "static/media/empty_top_matches.16fcd7e9.svg";